import React from 'react';

export const WaveHeadPattern: React.FC<{ fillColor: string }> = ({ fillColor }) => {
  return (
    <svg width="100%" height="100%" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <pattern id="wave-pattern" x="0" y="0" width="64" height="9" patternUnits="userSpaceOnUse">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.0025 3.99958C20.0022 1.99972 24.0017 0 32 0C40.0017 0 44.0022 2.00028 48.0025 4.00042C52.0022 6.00028 56.0017 8 64 8V9H0V8C8.00167 8 12.0022 5.99972 16.0025 3.99958Z"
            fill="white"
          />
        </pattern>
        <mask id="wave-mask">
          <rect fill="url(#wave-pattern)" x="0" y="0" width="100%" height="100%" />
        </mask>
      </defs>
      <g style={{ mask: 'url(#wave-mask)' }}>
        <rect fill={fillColor} width="100%" height="9" />
      </g>
      <rect x="0" y="8" width="100%" height="100%" fill={fillColor} />
    </svg>
  );
};
